<template>
  <el-col :span="normalizedSpan">
    <el-form-item :prop="name" :label="label" :label-width="labelWidth" :required="required" :rules="normalizedRules">
      <OLovInput v-model="model" :maxlength="maxlength" :placeholder="placeholder" :disabled="normalizedDisabled"
        @clear="onClear" @select="onSelect">
        <slot></slot>
      </OLovInput>
    </el-form-item>
  </el-col>
</template>

<script setup lang="ts">
import { ElCol, ElFormItem } from 'element-plus'
import type { FormLovInputProps } from './LovInput'
import OLovInput from '../../Input/LovInput/LovInput.vue'
import { useFormItemSpan, useFormItemRules, useFormItemModel, useFormContext, useFormItemDisabled } from '../hooks'
import { isString } from 'lodash-es'

defineOptions({ name: 'OFormLov', inheritAttrs: false })
const emit = defineEmits<{
  (e: 'select', params: Record<string, any>): void
  (e: 'clear'): void
}>()

const { name, label, labelWidth, required, maxlength, placeholder, fillMapping } = defineProps<FormLovInputProps>()
const normalizedSpan = useFormItemSpan()
const normalizedRules = useFormItemRules()
const normalizedDisabled = useFormItemDisabled()
const model = useFormItemModel()
const formContext = useFormContext()!

const onClear = () => {
  if (isString(fillMapping)) {
    const data: Record<string, any> = {}

    const pairs = fillMapping.split(',')
    for (let i = 0; i < pairs.length; i++) {
      const dstName = pairs[i].split(':')[0].trim()
      data[dstName] = undefined
    }

    formContext.updateModelValueMulti(data)

    emit('clear')
  }
}

const onSelect = (params: Record<string, any>) => {
  if (isString(fillMapping)) {
    const data: Record<string, any> = {}

    const pairs = fillMapping.split(',')
    for (let i = 0; i < pairs.length; i++) {
      const dstName = pairs[i].split(':')[0].trim()
      const srcName = pairs[i].split(':')[1].trim()
      const srcValue = params[srcName]
      data[dstName] = srcValue
    }

    formContext.updateModelValueMulti(data)
  } else {
    fillMapping && fillMapping(params)
  }

  emit('select', params)
}

</script>
